import { useState } from "react";
import assets from "../../assets";
import "./style.sass";
import { TEACHER_NAV_ICONS } from "../../utils/constant";
import { useNavigate, useLocation } from "react-router-dom";
import {LogoutPopup} from "../../components/logout-popup";
import { useAuth } from "../../hooks/use-auth";

export const TeacherBaseContainer = ({ children }) => {
  const navigate = useNavigate();
  const [isExpanded, setIsExpanded] = useState(false);
  const location = useLocation();
  const { logout } = useAuth();
  const [showLogoutModal, setShowLogoutModal] = useState(false);

  const handleLogout = () => {
    logout();
    navigate("/", { replace: true });
  };

  const renderNavItems = (item, index) => {
    const { icon, activeIcon, route,routes, label } = item || {};
    // const isActive = route && location.pathname === route;
    const isActive = routes
  ? routes.includes(location.pathname)
  : location.pathname === route;

    return (
      <section
        className={`nav_wrapper${isActive ? " active" : ""}`}
        key={index}
        data-tooltip={label}
        onClick={() => {
          route && navigate(route);
        }}
      >
        <span className="nav_icon">
          <img src={isActive ? activeIcon : icon} alt={label} />
        </span>
        <span className="nav_label">{label}</span>
      </section>
    );
  };

  return (
    <section className="base_container teacher_base">
      <section
        className={`nav_container${isExpanded ? " expanded" : ""}`}
        onMouseEnter={() => setIsExpanded(true)}
        onMouseLeave={() => setIsExpanded(false)}
      >
        <section className="nav_top_section">
          <section className="nav_logo_wrapper">
            <span className="nav_logo">
              <img src={assets.ic_logo} alt="logo" />
            </span>
            <span className="nav_brand">Rovian AI</span>
          </section>
          <section className="nav_items_wrapper">
            {TEACHER_NAV_ICONS.map(renderNavItems)}
          </section>
        </section>
        <section className="nav_bottom_section">
          <section className="nav_wrapper logout_btn" onClick={() =>  setShowLogoutModal(true)}>
            <span className="nav_icon">
              <img src={assets.ic_logout_grey} alt="logout" width={8} height={8}/>
            </span>
            <span className="nav_label">Log out</span>
          </section>
        </section>
      </section>
      <section className={`user_child_wrapper ${isExpanded ? "expanded" : ""}`}>
        <section className="content_area">{children}</section>
      </section>
          {showLogoutModal && (
              <LogoutPopup
                title="Logout"
                description="You'll be returned to the login screen. Any unsaved changes will be lost."
                btnText="Logout"
                onClose={() => setShowLogoutModal(false)}
                onLogout={handleLogout}
              />
            )}
    </section>
  );
};